import axios from '@axios';
import HelperService from '@/services/HelperService';

const base = 'api/v1/purple-phone/calls';
const helperService = new HelperService();

export default {
  get(id) {
    return axios.get(`${base}/${id}`);
  },
  list(filters) {
    const query = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/list${query}`);
  },
}
